import { useState } from 'react';

interface PdfObjectFallbackProps {
  url: string;
  className?: string;
}

export function PdfObjectFallback({ url, className }: PdfObjectFallbackProps) {
  const [supported, setSupported] = useState(true);
  return supported ? (
    <object
      data={url}
      type="application/pdf"
      className={className ?? 'h-[70vh] w-full rounded-md border'}
      onError={() => setSupported(false)}
    >
      <p className="p-4 text-xs text-muted-foreground">
        Your browser can&apos;t embed this PDF. Use the Open button above to view it in a new tab.
      </p>
    </object>
  ) : (
    <p className="rounded-md border p-4 text-xs text-muted-foreground">
      Inline PDF preview unavailable. Use the Open button above.
    </p>
  );
}
